export class GlobalConstants {
	public static LANGUAGES = {
		EN: 'en',
		FR: 'fr'
	};

	public static LOCAL_SBB_KEY_COOKIE = 'eq_sbb_uuid';

	public static CURRENT_BUILD = 'SBB-12.1.0';

	public static APP_TITLE = 'EQ Bank - SBB Onboarding';

	public static TRANSLATION_LANG_PATH ='../../../business/assets/i18n/';

	public static MARKETING_ROUTE_PATH = '/business/business-banking/business-account';
}
